import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PortalModule } from '@angular/cdk/portal';
// eslint-disable-next-line no-restricted-imports -- app shell is a reusable UI module in core library.
import { CmxWebComponentsModule } from '@cmx-web-components/angular';
import { AppShellLayoutComponent } from './app-shell-layout.component';

@NgModule({
  declarations: [AppShellLayoutComponent],
  imports: [CommonModule, RouterModule, PortalModule, CmxWebComponentsModule],
  exports: [AppShellLayoutComponent, CmxWebComponentsModule],
})
export class AppShellLayoutModule {}
